import { z } from 'zod';
import { DateRange, Translations } from 'types/Common';
import { IAlternativeEmployee } from 'types/income';
import { BenefitCategory } from 'store/benefits';
import {
  alternativeEmployeesFiltersSchema,
  alternativesFiltersSchema,
} from './alternatives.schemas';

export const alternativeSelectionStatuses = [
  'selected',
  'notSelected',
  'expired',
  'notAssigned',
] as const;
export type AlternativeSelectionStatus =
  (typeof alternativeSelectionStatuses)[number];

export const alternativeEmployeesAssignmentStatuses = [
  'assignedIndividually',
  'assignedPerGroup',
  'notAssigned',
] as const;
export type AlternativeEmployeesAssignmentStatus =
  (typeof alternativeEmployeesAssignmentStatuses)[number];

export const selectionPeriods = ['range', 'inDays'] as const;
export type SelectionPeriod = (typeof selectionPeriods)[number];

export interface BaseAlternative {
  id: string;
  name: string;
  isActive: boolean;
  assignments: number;
  benefits: number;
  selections: number;
  missingSelections: number;
}

export interface Alternative extends BaseAlternative {
  assignedGroupsCount: number;
  maxSelections: number;
  deadlineType: SelectionPeriod;
  deadlineRange?: Required<DateRange>;
  deadlineInDays: number;
}

export interface AlternativeContent {
  translations: Translations<{
    title: string;
    description: string;
  }>;
}

export interface AlternativeBenefit {
  id: string;
  name: string;
  type: BenefitCategory;
  validFrom: string | null;
  validTo: string | null;
  value: number;
  investmentAmount: number;
}

export interface AlternativeEmployee extends IAlternativeEmployee {
  isLocked: boolean;
}

export interface ExportAlternativesFilters {
  alternatives: string[];
}

export interface AlternativeEmployeesGroup {
  id: string;
  name: string;
  isAssigned: boolean;
  employeesCount: number;
}

export type AlternativesFilters = z.infer<typeof alternativesFiltersSchema>;

export type AlternativeEmployeesFilters = z.infer<
  typeof alternativeEmployeesFiltersSchema
>;
